import { query, queryAll, ready } from "./dom";

const elements = {
  commentInput: () => query("#id_comment"),
  replyToButtons: () => queryAll(".js-comment-reply"),
  replyToInput: () => query("#id_reply_to"),
  replyToText: () => query("#comment-replying-to"),
};

const onReplyClick = (event) => {
  const id = event.target.dataset.id;
  elements.replyToText().textContent = `Vastaamassa kommenttiin #${id}`;
  elements.replyToInput().value = id;
  location.href = "#comment_form";
  elements.commentInput().focus();
};

export const setup = () => {
  elements.replyToButtons().forEach((elem) => {
    elem.addEventListener("click", onReplyClick);
  });
  const error = query("#comment_form .js-error");
  if (error) {
    ready(() => {
      error.scrollIntoView();
    });
  }
};
